// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1F8h9","requiredAsterisk":"Info_requiredAsterisk__2k5D7"};